import { NavLink } from 'react-router-dom';
import { navGroups, navItems } from '../navigation';

export default function SidebarNav({ onNavigate }: Props) {
  return (
    <nav className="nav-items" aria-label="주요 메뉴">
      {navGroups.map((group) => (
        <div className="nav-section" key={group.scope}>
          <span className="nav-section-label">{group.label}</span>
          {navItems
            .filter((item) => item.scope === group.scope)
            .map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={onNavigate}
                className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
              >
                <span className={`nav-marker ${item.scope.toLowerCase()}`}>
                  {item.marker}
                </span>
                {item.label}
              </NavLink>
            ))}
        </div>
      ))}
    </nav>
  );
}

type Props = { onNavigate?: () => void };
